
import React, { createContext, useContext, useState, useMemo } from 'react';

const AppSettingsContext = createContext(null);

export function AppSettingsProvider({ initialSettings = {}, children }) {
    const [settings, setSettings] = useState(initialSettings);

    const updateSettings = (partial) => {
        setSettings((prev) => ({ ...prev, ...partial }));
    };

    const resetSettings = (next = {}) => {
        setSettings(next);
    };

    const value = useMemo(
        () => ({ settings, updateSettings, resetSettings }),
        [settings]
    );

    return (
        <AppSettingsContext.Provider value={value}>
            {children}
        </AppSettingsContext.Provider>
    );
}

/**
 * Hook to use the app settings in any component
 */
export function useAppSettings() {
    const ctx = useContext(AppSettingsContext);
    if (!ctx) {
        throw new Error('useAppSettings must be used within an AppProvider');
    }
    return ctx;
}
